/** @format */

const publicationsList = document.querySelector(
	'#mcw-anesth-publications-list'
);
const staffPublicationsList = document.querySelector(
	'#mcw-anesth-staff-publications-list'
);

if (publicationsList) {
	createPublications();
}

if (staffPublicationsList) {
	createStaffPublications();
}

async function createPublications() {
	const PublicationsList = await import(
		'./svelte-components/Publications/PublicationsList.svelte'
	).then((r) => r.default);

	new PublicationsList({
		target: publicationsList,
	});
}

async function createStaffPublications() {
	const StaffPublicationsList = await import(
		'./svelte-components/Publications/StaffPublicationsList.svelte'
	).then((r) => r.default);

	new StaffPublicationsList({
		target: staffPublicationsList,
	});
}
